export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.1-1129.02",
  commitId: "84374ce131c3ae248037f27b5c078be7bc79f0ab",
  commitTime: "2026-05-01T11:29:02.000Z",
});
